import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { class: "row justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", null, "Billing templates list", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_billing_templates_list = _resolveComponent("billing-templates-list", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_q_btn, {
        label: "Add billing template",
        color: "primary",
        onClick: _ctx.onAddBillingTemplate,
        unelevated: "",
        "no-caps": "",
        class: "self-start"
      }, null, 8, ["onClick"])
    ]),
    _createVNode(_component_billing_templates_list, { organizationId: _ctx.organizationId }, null, 8, ["organizationId"])
  ]))
}